import { api } from "./api";

export const listarAnexos = (idFicha) => api.get(`/anexo/ficha/${idFicha}`);

export const uploadAnexo = (idFicha, arquivo, categoria, idTipoDocumento) => {
  const fd = new FormData();
  fd.append("arquivo", arquivo);
  if (categoria) fd.append("categoria", categoria);
  if (idTipoDocumento) fd.append("idTipoDocumento", idTipoDocumento);
  // Content-Type undefined → axios define multipart/form-data com boundary correto.
  return api.post(`/anexo/upload/${idFicha}`, fd, { headers: { "Content-Type": undefined } });
};

export const excluirAnexo = (id) => api.post(`/anexo/excluir/${id}`);
export const avaliarAnexo = (id, status, motivo) =>
  api.post(`/anexo/avaliar/${id}`, { Status: status, Motivo: motivo });
export const getAnexoBlob = (id) =>
  api.get(`/anexo/download/${id}`, { responseType: "blob" }).then((r) => r.data);

// Baixa o arquivo como blob e dispara o download no browser preservando o nome.
export const baixarAnexo = async (id, nomeOriginal) => {
  const { data } = await api.get(`/anexo/download/${id}`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeOriginal || `anexo_${id}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
